<template>
  <a-card v-if="getScreen">
    <span slot="title">Credit Card PD Claim Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="PD Fee Report Detail" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          type="default"
          :loading="btnLoading"
          @click="validasi"
          :disabled="dataList.length < 1"
          >{{ status === false ? "Save Draft" : "Save" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card
        :loading="loading"
        class="m-height-full m-display-flex flex-column"
      >
        <span slot="title">Credit Card PD Claim Form</span>
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="PD Fee Report Detail" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component
            class="flex-1"
            :is="steps[current].content"
            :ref="stepRef"
            v-bind="stepProps"
          ></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
            <a-button
              v-if="current == 1"
              type="primary"
              @click="handleNew"
              :loading="loadingAdd"
              :disabled="disabledonLoadSPPDDtl"
              >Add</a-button
            >
            <a-button
              v-if="current < steps.length - 1"
              type="default"
              @click="next"
              :loading="loadingNextStep1"
              :disabled="disabledonLoadSPPDDtl"
              >Next</a-button
            >
            
            <a-button
              v-if="type !== 'revised' && current == (steps.length - 1)"
              type="default"
              @click="validasiDraft"
              :disabled="disableSaveButton"
              >Save Draft</a-button
            >
            <a-button
              v-if="current == (steps.length - 1)"
              type="primary"
              @click="validasi"
              :disabled="disableSaveButton"
              :loading="LoadingSave"
              >Save</a-button
            >
            </a-button-group>
            <a-button v-if="current > 0" @click="prev" :disabled="disabledonLoadSPPDDtl">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex nowrap flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <a-button :disabled="stepRef == 'refInformasi'" @click="onCollective" class="margin-right-small" icon="edit" :loading="loadingCollective"
            >Collective</a-button
          >
          <a-button @click="handleExpand()">
            <span>{{ labelExpand }}</span>
          </a-button>
        </template>
        <div class="body-flex">
          <a-table
            :columns="columns"
            :dataSource="getCountWeb"
            :pagination="pagination"
            size="small"
            :scroll="{ x: 610 }"
            bordered
          >
            <div slot="deskripsi" slot-scope="index, item">
              <h4 class="margin-remove">{{ item.deskripsi }}</h4>
              <small
                >{{ item.item_nm }}
                {{
                  item.kode_anggaran ? " | " + item.kode_anggaran : ""
                }}</small
              >
              <a-alert
                type="error"
                banner
                v-if="
                  item.kredit != '' &&
                  (item.kode_anggaran == null || item.kode_anggaran == '')
                "
                message="item anggaran cannot be empty"
              />
            </div>
            <template slot="commission" slot-scope="index, item">
              <span v-if="item.iscommision=='1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
            </template>
            <template slot="document" slot-scope="index, item">
              <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                View Document
              </a>
              <span v-else>
                No File Uploaded
              </span>
            </template>
            <template slot="operation" slot-scope="index, item">
              <a-button-group v-if="item.kredit">
                <a-button
                  type="primary"
                  :loading="loadingBtnEdit && idlistEdit == item.id"
                  @click="handleEdit(item)"
                >
                  <a-icon type="edit" />
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)" :loading="loadingRemove">
                  <a-icon type="close" />
                </a-button>
              </a-button-group>
            </template>
          </a-table>
          <div class="m-price-total" v-if="loading === false">
            <div class="m-display-flex space-between align-middle">
              <h4>Total Credit</h4>
              <h3>{{ formatRupiah(kredit) }}</h3>
            </div>
          </div>
        </div>
        <!-- <template class="ant-card-actions" slot="actions">
          <div
            class="steps-action"
            v-if="
              current == steps.length - 1 ||
              (mode === 'Edit' && type !== 'draft')
            "
          >
            <a-button
              type="default"
              @click="validasi"
              :disabled="disableSaveButton"
              >Save</a-button
            >
            <a-button
              v-if="type !== 'revised'"
              type="default"
              @click="validasiDraft"
              :disabled="disableSaveButton"
              >Save Draft</a-button
            >
          </div>
        </template> -->
      </a-card>
    </a-col>
    <a-modal
      title="Konfirmasi"
      :visible="confirm"
      @ok="handleOk(type)"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      okText="OK"
      cancelText="Cancel"
    >
      <p>
        This data that has been added will be overwritten with your new file,
        are you sure?
      </p>
    </a-modal>
    <Modal
      v-if="modal.modalEdit"
      :dataParent="modal.data"
      :reportingList="dataList"
      :sppdList="sppdDetail"
      :modalEdit="modal.modalEdit"
    />

    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title"><a-icon type="edit" />&nbsp;Edit Collective</div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-form-item label="SPPD Detail">
            <a-select
              showSearch
              placeholder="Select sppd"
              @change="handleSppd"
              option-filter-prop="children"
              :filter-option="filterOption"
              class="m-width-full"
              v-decorator="[
                'id_sppd_dtl',
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in sppd"
                :key="item.id_sppd_dtl"
                style="width: 100% !important"
              >
                <div class="elipsdiv">
                  <div class="elipsdiv-mouseover-label1">
                    {{ item.item_nm }}
                    <small v-if="!getScreen">|</small>
                    <small v-if="!getScreen">{{ item.kode_anggaran }}</small>
                  </div>
                  <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">
                      {{
                        formatCurrency(
                          "IDR",
                          parseFloat(item.saldo_anggaran)
                        ).replace(",00", "")
                      }}
                    </b>
                  </div>
                </div>
              </a-select-option>
            </a-select>
          </a-form-item>
                    <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :columns="columns"
          :dataSource="getCountWeb"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 610 }"
          bordered
        >
          <div slot="deskripsi" slot-scope="index, item">
            <h4 class="margin-remove">{{ item.deskripsi }}</h4>
            <small
              >{{ item.item_nm }}
              {{ item.kode_anggaran ? " | " + item.kode_anggaran : "" }}</small
            >
            <a-alert
              type="error"
              banner
              v-if="
                item.kredit != '' &&
                (item.kode_anggaran == null || item.kode_anggaran == '')
              "
              message="item anggaran cannot be empty"
            />
          </div>
          <template slot="commission" slot-scope="index, item">
            <span v-if="item.iscommision=='1'">
              Yes
            </span>
            <span v-else>
              No
            </span>
          </template>
          <template slot="document" slot-scope="index, item">
              <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                View Document
              </a>
              <span v-else>
                No File Uploaded
              </span>
            </template>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              :checked="
                selected.filter((obj) => obj.id == item.id).length == 0
                  ? false
                  : true
              "
              @change="handleCheck"
              :value="item"
            />
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button
          @click="handleSet"
          type="primary"
          :disabled="selected.length == 0"
          :loading="loadingSet"
          >Set</a-button
        >
        <a-button
          @click="handleCloseCollective"
          :type="selected.length == 0 ? 'primary' : ''"
          :loading="loadingSetDone"
          >Done</a-button
        >
      </a-button-group>
    </Collective>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Informasi from "./steps/InformasiKlaimPd.vue";
import Pemakaian from "./steps/PemakaianKlaimPd.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleMessage from "@/mixins/HandleMessage";
import collectiveCCPD from "@/mixins/collective/collectiveCCPD";
import nanoid from "nanoid";
import Modal from "./Modal.vue";
import moment from "moment";
import Loading from "@/components/preloader/Loading.vue";
import Collective from "@/components/collective/Collective.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "CreateKlaimCCPd",
  props: ["id", "type"],
  components: {
    Informasi,
    Pemakaian,
    Approval,
    Modal,
    Collective,
    Loading,
  },
  mixins: [CurrencyFormat, HandleMessage, collectiveCCPD, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      sppdDetail: [],
      collectData: {},
      mode: "Create",
      id_klaim: "",
      active: false,
      status: false,
      dataList: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => {},
        pageSize: 4,
        size: "small",
      },
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          id_sppd_dtl: "",
          type: "",
        },
      },
      confirmLoading: false,
      confirm: false,
      btnLoading: false,
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingBtnEdit: false,
      idlistEdit: undefined,
      loadingAdd: false,
      EnCommission: true,
      Viwithout_note: true,
      doctransfiles:[],
      loadingNextStep1: false,
      disabledonLoadSPPDDtl: false,
      loadingRemove: false,
      LoadingSave: false
    };
  },
  async created() {
    this.id_klaim = nanoid(11);
    await this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDetailSppd",
    ]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_klaim: this.collectData.others.id_klaim,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
            type: this.type,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_klaim: this.id_klaim,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        return "refPemakaian";
      } else{
        return "refApproval";
      }
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 100,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          dataIndex: "deskripsi",
          key: "deskripsi",
          width: 250,
          scopedSlots: { customRender: "deskripsi" },
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Commission",
          key: "commission",
          scopedSlots: { customRender: "commission" },
          width: 125,
          align: "center"
        },
        {
          title: "Credit",
          dataIndex: "kredit_value",
          key: "kredit_value",
          align: "right",
          width: 175,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
        },
        {
          title: this.isCollective ? "Check" : "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.dataList;
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;
          //
          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            data[index]["sisa"] = this.formatCurrency(
              this.mata_uang,
              debit - value.kredit
            );
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
          data[index]["iscommision"] = value.iscommision;
          data[index]["without_note"] = value.without_note;
        });
      }
      return data;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
  },
  methods: {
    moment,
    fetch() {
      if (this.id) {
        this.mode = "Edit";
        if (this.type === "draft") {
          this.url = this.$serviceUrl + "klaim_cc_pd/detil_pemakaian";
          this.fetchEdit(this.url);
        } else {
          this.url = this.$serviceUrl + "klaim_cc_pd/revisi_detil_pemakaian";
          this.fetchEdit(this.url);
          this.type = "revised";
        }
      } else if (this.mode === "Create") {
        this.url = this.$serviceUrl + "klaim_cc_pd/detil_pemakaian";
        this.loading = false;
      }

      if (this.id && this.mode === "Edit" && !this.getScreen && this.loading) {
        this.fetchPemakaian();
      }
    },
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Pemakaian") {
        //this.$refs.refPemakaian.handleRef();
        if(this.dataList.length<=0){
            this.displayMessageValue(
              "error-other",
              "Data Details can't be empty, because this transaction has at least 1 data!"
            );
        }else{
          let exceedDate = _.filter(this.dataList, item => moment(item.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
          if(exceedDate.length>0){
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }
          this.getApproval();
        }
      }
    },
    prev() {
      if(this.steps[this.current].content === "Approval"){
        this.$refs.refApproval.handleRef();
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    validasi() {
      if (!this.getScreen) {
        this.status = true;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    validasiDraft() {
      if (!this.getScreen) {
        this.status = false;
      }
      this.confirmMessage("confirm-save-draft");
    },
    validate() {
      this.$refs.refApproval.handleRef();
      this.btnLoading = true;
      
      if (this.status) {
        let postData;
        let method;
        let contentType;
        let link;
        
        if (this.type === "revised") {
          method = "put";
          contentType = "application/json";
          link = "/pu/klaimmanifestpd/" + this.collectData.others.id_klaim;
          postData = {
            tlc: this.getAuth.username,
            id_klaim: this.id,
            no_sppd: this.collectData.informasi.no_sppd,
            tanggal_pelaporan: moment(
              this.collectData.informasi.tanggal_pelaporan
            ).format(this.getStandartFormatDate),
            public_manifest_url: link,
            catatan: this.collectData.informasi.catatan ?
              this.collectData.informasi.catatan : '',
              id_user_cc: this.collectData.informasi.id_user_cc ?
              this.collectData.informasi.id_user_cc : '',
          };
        } else {
          method = "post";
          contentType = "multipart/form-data";
          postData = new FormData();
          link = "/pu/klaimmanifestpd/" + this.id_klaim;

          if (this.mode === "Edit") {
            postData.append("id_klaim", this.collectData.others.id_klaim);
          } else {
            postData.append("id_klaim", this.id_klaim);
          }
          postData.append("tlc", this.getAuth.username);
          postData.append("no_sppd", this.collectData.informasi.no_sppd);
          postData.append(
            "tanggal_pelaporan",
            moment(this.collectData.informasi.tanggal_pelaporan).format(
              this.getStandartFormatDate
            )
          );
          postData.append("public_manifest_url", link);
          postData.append("catatan", this.collectData.informasi.catatan ?
            this.collectData.informasi.catatan : '');
          postData.append("id_user_cc", this.collectData.informasi.id_user_cc ?
            this.collectData.informasi.id_user_cc : '');
        }

        this.LoadingSave = true
        axios({
          method: method,
          url: this.$serviceUrl + "klaim_cc_pd",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": contentType,
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.LoadingSave = false
            this.displayMessage("success-save");
            this.btnLoading = false;
            this.$router.push({ name: "klaimCCPDList" });
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            if (responses.message) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
            this.LoadingSave = false
            this.btnLoading = false;
          });
      } else {
        axios({
          method: "post",
          url: this.$serviceUrl + "klaim_cc_pd/draft",
          data: {
            id_klaim : this.id ? this.id : this.id_klaim,
            id_user_cc: this.collectData.informasi.id_user_cc,
            catatan: this.collectData.informasi.catatan
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.displayMessage("success-edit");
            this.$router.push({ name: "klaimCCPDList" });
          })
          .catch((response) => {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error-other",responses);
          });
      }
    },
    async valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.loadingNextStep1 = true;
        await axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "klaim_cc_pd/sppd_detil",
          params: {
            id_sppd: this.collectData.informasi.id_sppd,
            id_klaim_draft: this.id_klaim,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((res) => {
          //console.log(res);
          this.loadingNextStep1 = false;
          this.current++;
        });
      } else if (this.steps[this.current].content === "Pemakaian") {
        this.current++;
      } else if (this.steps[this.current].content === "Approval"){
        this.collectData.informasi.catatan = value.note;
      }
    },
    controlForm(value) {
      this.active = value;
    },
    draftStatus(val) {
      this.status = val;
    },
    fetchEdit(url) {
      axios({
        method: "get",
        url: url,
        params: {
          id_klaim: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            detil_pemakaian: response.data.detail_pemakaian,
            informasi: {
              no_sppd: response.data.no_sppd,
              id_sppd: response.data.id_sppd,
              tanggal_pelaporan: response.data.tgl_buat,
              pimpro: response.data.pimpro,
              bod: response.data.bod + " - " + response.data.nama_bod,
              bod_name: response.data.nama_bod,
              catatan: response.data.catatan,
              id_user_cc: response.data.id_user_cc,
            },
            others: {
              mata_uang: response.data.mata_uang,
              id_klaim: response.data.id_klaim,
              peruntukan: response.data.peruntukan,
              sisa_saldo: response.data.sisa_saldo,
              total_debit: response.data.total_debit,
              total_kredit: response.data.total_kredit,
              assignee:  response.data.assignee
            },
          };
          this.loading = false;
        })
        .catch((err) => {
          this.displayMessage("error-getdetil");
          // this.$router.go(-1);
        });
    },
    fetchPemakaian() {
      let id_klaim = "";
      this.loadingAdd = true;
      if (this.mode == "Edit") {
        id_klaim = this.id;
      } else if (this.mode === "Create") {
        id_klaim = this.collectData.informasi.no_sppd;
      }

      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_klaim: id_klaim,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian;
            this.kredit = response.data.total_kredit;
            this.mata_uang = response.data.mata_uang;
            if (this.$refs.refPemakaian) this.$refs.refPemakaian.done();
            if (this.dataList.length === 1) {
              this.active = false;
            }
            this.loadingAdd = false;
          })
          .catch((err) => {
            let response = Object.assign({}, err.response.data);
            if (response.message === "Tidak Memiliki Detil Pemakaian") {
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.collectData = {};
              this.debit = 0;
              this.kredit = 0;
            } else if (
              response.message ===
              "Belum Memiliki Detil Pemakaian, Silahkan Menambahkan."
            ) {
              this.displayMessage("no-detil-klaimsppd");
              this.$router.push({ name: "klaimCCPDList" });
            }
            this.$refs.refPemakaian.done();
            this.loading = false;
            this.loadingAdd = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_klaim: id_klaim,
              mode: this.mode,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian;
              this.kredit = response.data.total_kredit;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              let response = Object.assign({}, err.response.data);
              if (response.message === "Tidak Memiliki Detil Pemakaian") {
                this.current = 0;
                this.active = false;
                this.mode = "Create";
                this.collectData = {};
                this.$refs.refPemakaian.done();
              } else if (
                response.message ===
                "Belum Memiliki Detil Pemakaian, Silahkan Menambahkan."
              ) {
                this.displayMessage("no-detil-klaimsppd");
                this.$router.push({ name: "klaimCCPDList" });
              }
              this.loading = false;
              this.loadingAdd = false;
            });
        }
      }
    },
    async handleFetchEdit(item) {
      const url =
        this.type == "revised"
          ? "klaim_cc_pd/revisi_detil_pemakaian_update"
          : "klaim_cc_pd/detil_pemakaian_update";
      return await axios({
        method: "get",
        url: this.$serviceUrl + url,
        params: {
          id_dtl_klaim: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleCheckData(e) {
      this.draftStatus(e.target.checked);
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item) {
      this.loadingBtnEdit = true;
      this.idlistEdit = item.id;
      this.handleFetchEdit(item)
        .then((result) => {
          this.sppdDetail = result.data.list_dtl_sppd;
          this.modal.data = {
            tanggal_pemakaian: result.data.tgl,
            deskripsi: result.data.detail,
            kredit: result.data.kredit,
            id: result.data.id_dtl,
            id_sppd_dtl: result.data.selected_sppd_dtl,
            type: this.type,
            iscommision: item.iscommision ? item.iscommision : "0",
            without_note: item.without_note ? item.without_note : "1",
            id_user_cc: item.id_user_cc
          };

          if (!result.data.iscommision){
            this.modal.data.EnCommission=true;
            this.modal.data.Viwithout_note=true;
          }else if(result.data.iscommision=="1" && result.data.iscommision_ori){
            this.modal.data.EnCommission=true;
            this.modal.data.Viwithout_note=false;
          }else if(result.data.iscommision=="1" && !result.data.iscommision_ori){
            this.modal.data.EnCommission=false;
            this.modal.data.Viwithout_note=false;
          }else{
            this.modal.data.iscommision=="0";
            this.modal.data.EnCommission=false;
            this.modal.data.Viwithout_note=true;
          }

          if (item.lampiran) {
            this.loadingBtnEdit = true;
            this.asyncAxiosGet("main/base_64", this.getAuth, {
              path: item.lampiran_path,
            })
              .then((response) => {
                let typefile = this.fileTypeFromUrl(item.lampiran);
                let file = this.dataURLtoFile(
                  typefile + response.file_document_tax,
                  item.lampiran
                );
                file.uid = "vc-upload-1-1";
                file.status = "done";
                file.url = this.$serviceUrl + item.lampiran_path;
                this.modal.data.doctransfiles = [];
                this.modal.data.doctransfiles.push(file);

                this.modal.modalEdit = true;
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
              })
              .catch((err) => {
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
                console.log(err);
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
              });
          } else {
            this.modal.modalEdit = true;
            this.loadingBtnEdit = false;
            this.idlistEdit = undefined;
          }
        })
        .catch(() => {
          this.loadingBtnEdit = false;
          this.idlistEdit = undefined;
        });
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
    },
    handleRemoveDetail(item) {
      // if (this.getCountWeb.length == 1) {
      //   this.displayMessage("detail-cannot-empty");
      // } else {
      this.confirmMessageValue("confirm-delete", item);
      // }
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      let url =
        this.type === "revised"
          ? "klaim_cc_pd/revisi_detil_pemakaian"
          : "klaim_cc_pd/detil_pemakaian";
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };

      this.loadingRemove = true
      axios({
        method: "delete",
        url: serviceUrl + url,
        processData: false,
        data: {
          id: item.id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.loadingRemove = false
          Event.$emit("fetchSppd", 0);
          this.fetchPemakaian();
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    switchMode(value) {
      this.mode = value;
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    async getApproval(){
      let params = {
        tlc : this.getAuth.username,
        no_sppd : this.collectData.informasi.no_sppd,
        id_klaim : this.id ? this.id : null,
        is_draft: this.type=='revised' ? 0 : 1,
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "klaim_cc_pd/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.formCollective.setFieldsValue({
              without_note: "0",
          });
        });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    fdisabledonLoadSPPDDtl(val){
      this.disabledonLoadSPPDDtl = val
    }
  },
  mounted() {
    Event.$on("lapUmpd", this.valueFromChild);
    Event.$on("disableInformasi", this.controlForm);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("switchMode", this.switchMode);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("handleLoading", this.handleLoading);
    Event.$on("fdisabledonLoadSPPDDtl", this.fdisabledonLoadSPPDDtl);
  },
  beforeDestroy() {
    Event.$off("lapUmpd", this.valueFromChild);
    Event.$off("disableInformasi", this.controlForm);
    Event.$off("draftStatus", this.draftStatus);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("removeDetail", this.handleRemoveDetail);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("fdisabledonLoadSPPDDtl", this.fdisabledonLoadSPPDDtl);
  },
};
</script>

<style lang="less" scoped>
.body-flex {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  .ant-table-wrapper {
    flex: 1;
  }
}
</style>
